document.addEventListener('DOMContentLoaded', function () {
  // Ficha de producto: mostrar todas las imágenes
  if (document.body.classList.contains('template-product-calcetines')) {
    const showAllImages = () => {
      document.querySelectorAll('.media-gallery__list li').forEach(li => {
        li.removeAttribute('hidden');
        li.removeAttribute('aria-hidden');
        li.style.display = 'block';
        li.style.opacity = '1';
        li.style.visibility = 'visible';
      });
    };
    showAllImages();
    document.addEventListener('variant:change', showAllImages);
    setInterval(showAllImages, 500);
  }

  // Colección calcetines: mostrar las 3 imágenes en tarjeta
  if (window.location.pathname === '/collections/calcetines') {
    document.body.classList.add('collection-calcetines');
  }
});
